import { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/useAuth.js';

const PRODUCTS = [
  { label: 'M8',      product: 'm8'      },
  { label: 'COP-LOP', product: 'cop-lop' },
  { label: 'Avira',   product: 'avira'   },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [devicesOpen, setDevicesOpen] = useState(true);

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  const isDevicesActive = location.pathname === '/devices' || location.pathname.startsWith('/devices/');

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-56 bg-gray-900 text-white flex flex-col">
        <div className="px-4 py-5 border-b border-gray-700">
          <p className="font-bold text-lg">M8 Admin</p>
          <p className="text-xs text-gray-400 mt-0.5">Haron</p>
        </div>
        <nav className="flex-1 py-4 space-y-0.5">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Dashboard
          </NavLink>

          {/* Device Management toggle */}
          <button
            onClick={() => setDevicesOpen((o) => !o)}
            className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors ${isDevicesActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`}
          >
            <span>Device Management</span>
            <span className="text-xs opacity-60">{devicesOpen ? '▾' : '▸'}</span>
          </button>
          {devicesOpen && PRODUCTS.map(({ label, product }) => {
            const isActive = location.pathname === '/devices' && location.search === `?product=${product}`;
            return (
              <NavLink
                key={product}
                to={`/devices?product=${product}`}
                className={() =>
                  `block pl-8 pr-4 py-2 text-xs transition-colors ${isActive ? 'text-white font-semibold bg-indigo-700' : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800'}`
                }
              >
                {label}
              </NavLink>
            );
          })}

          <NavLink
            to="/services"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Service Management
          </NavLink>
          <NavLink
            to="/users"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Users
          </NavLink>
          <NavLink
            to="/members"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Members
          </NavLink>
          <NavLink
            to="/firmware"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Firmware
          </NavLink>
          <NavLink
            to="/app-roles"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            App Roles
          </NavLink>
          <NavLink
            to="/warranty"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Warranty
          </NavLink>
          <NavLink
            to="/warranty-settings"
            className={({ isActive }) =>
              `block pl-8 pr-4 py-2 text-xs transition-colors ${isActive ? 'text-white font-semibold bg-indigo-700' : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800'}`
            }
          >
            Warranty Settings
          </NavLink>
          <NavLink
            to="/production-testers"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Production Testers
          </NavLink>
          <NavLink
            to="/reports"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Reports
          </NavLink>
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            FAQ
          </NavLink>
<NavLink
            to="/content-documents"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            Content Management
          </NavLink>
          <NavLink
            to="/app-management"
            className={({ isActive }) =>
              `block px-4 py-2.5 text-sm transition-colors ${isActive ? 'bg-indigo-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`
            }
          >
            App Management
          </NavLink>
        </nav>
        <div className="px-4 py-4 border-t border-gray-700">
          <p className="text-xs text-gray-400 truncate mb-2">{user?.mobile ?? ''}</p>
          <button
            onClick={handleLogout}
            className="w-full text-left text-sm text-gray-300 hover:text-white transition-colors"
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
